export { SORT_DIRECTIONS } from "../tableConstants";

export const POLICY_TABS = {
  CANCELATION: 0,
  SEASONAL: 1,
};

export const CANCEL_PAYMENT_TYPE_DISPLAY = {
  PERCENT: (amount) => `${amount}% of Total Charge`,
  // `amount` arrives pre-formatted by the shared formatCurrency
  // (symbol + separators, e.g. "$1,500.00") — see formatCancelPaymentAmount.
  FLAT: (amount) => `${amount} Flat Fee`,
  NIGHT: (amount) => `${amount} Night(s) Charge`,
  NO_DEDUCT: () => "No Deduction",
};
